// extracted by mini-css-extract-plugin
module.exports = {"content":"content__C3NsDKGU72Jjk","link":"link__V3yrZk4IuQwDN"};